<template>
    <b-container>
        <b-row class="justify-content-center">
            <b-col cols="12" class="text-left">
                <p>Carica la visura camerale della società.<br>
                    Deve essere nel formato PDF e pesare al massimo 5 Mb.</p>
            </b-col>
            <b-col cols="12" md="12" class="mb-3 UploadImportFile">
                <vue-dropzone
                        ref="InterDropZoneImport"
                        id="InterDropZoneImport"
                        :useCustomSlot="true"
                        :options="dropzoneOptions"
                        v-on:vdropzone-success="uploaded"
                        v-on:vdropzone-error="handleError"
                >
                    <div class="UploadImportFile-dropZone">
                        <h3 class="UploadImportFile-title">
                            Drag and drop per caricare un file
                        </h3>
                        <div class="UploadImportFile-subtitle">
                            ...o clicca per selezionare un file dal tuo computer
                        </div>
                    </div>
                </vue-dropzone>
            </b-col>
        </b-row>
        <b-row class="justify-content-center" v-if="enableReupload">
            <b-col class="col-auto">
                <inter-button
                        @onClick="uploadManually"
                        :label="buttonPrimary.label"
                        :confirm="buttonPrimary.confirm"
                >
                </inter-button>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone';
    import InterButton from "../../../../components/form/inter-button/InterButton";
    import _ from "lodash";

    export default {
        name: "RegisterWizardStepFour",
        components: {InterButton, vueDropzone: vue2Dropzone},
        data: function () {
            return {
                enableReupload: false,
                buttonPrimary: {
                    label: 'Carica un altro file',
                    confirm: true
                },
                file: {},
                response: {}
            }
        },
        computed: {

            dropzoneOptions: function () {
                return {
                    url: process.env.VUE_APP_API_URL + '/api/v1/media/upload/chamber-of-commerce',
                    headers: {
                        "client": process.env.VUE_APP_OAUTH_CLIENT_NAME,
                        "Authorization": 'Bearer ' + this.accessToken
                    },
                    renameFile:"chamberOfCommerce",
                    acceptedFiles: "application/pdf",
                    createImageThumbnails: false
                }
            },

        },

        methods: {

            uploaded: function (file, response) {
                this.enableReupload = true;
                this.file = file;
                this.response = response;
                this.$emit('onUploaded', response);
            },
            uploadManually: function () {
                this.enableReupload = false;
                this.$refs.InterDropZoneImport.removeAllFiles();
                this.response = {};
                this.file = {};
            },
            handleError: function() {
                this.$refs.InterDropZoneImport.removeAllFiles();
                this.response = {};
                this.file = {};
                this.$bvToast.toast('File non caricato correttamente', {
                    title: 'Alert',
                    variant: 'warning'
                });
            },
            validate: function () {
                if (!_.isEmpty(this.response)) {
                    return true;
                } else {
                    this.$bvToast.toast('Non hai caricato la visura camerale', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                    return false;
                }
            },
        }
    }
</script>

<style scoped>

</style>
